import z from 'zod';
import { COMMISSION, MEMBERSHIP, SUPPORT } from '../constant';

export const uid = z.string().min(1);
export const store_id = z.number().positive();
export const NumericStringSchema = z.string().regex(/^\d+$/, 'must contain only numeric characters');
export const NumericArrayStringSchema = z
  .string()
  .regex(/^(\d+,)*\d+$/, 'must contain only numeric characters');

export const MembershipPermissionControllerReqBodySchema = z.object({
  store_id,
  owner_uid: uid.optional(),
  proxy_uid: uid,
});

const MembershipStoreControllerProjectReqQuerySchema = z.object({
  store_ids: z.undefined(),
  project_ids: NumericArrayStringSchema,
});

const MembershipStoreControllerStoreReqQuerySchema = z.object({
  store_ids: NumericArrayStringSchema,
  project_ids: z.undefined(),
});

export const MembershipStoreOwnerControllerReqQuerySchema = z.object({
  project_ids: NumericArrayStringSchema,
});

export const MembershipStoreControllerReqQuerySchema = z.union([
  MembershipStoreControllerProjectReqQuerySchema,
  MembershipStoreControllerStoreReqQuerySchema,
]);

export const MembershipAdjustmentSchema = z.object({
  amount: z.string(), // 정산되어야 하는 금액 (원, 수수료 제외 전 금액)
  type: z.enum(['PAYMENT', 'REFUND']), // 정산의 타입, 결제/환불
  service: z.enum([MEMBERSHIP, SUPPORT, COMMISSION]), // 정산 서비스 타입, 멤버십/후원
  membership_project_id: z.string(), // 프로젝트 ID
  membership_id: z.string().optional(), // 멤버십 ID, 멤버십일 경우에만 입력
  membership_name: z.string().optional(), // 멤버십 이름, 멤버십일 경우에만 입력
  commission_id: z.string().optional(), // 커미션 ID, 커미션일 경우에만 입력
  commission_name: z.string().optional(), // 커미션 이름, 커미션일 경우에만 입력
  support_id: z.string().optional(), // 후원 ID, 후원일 경우에만 입력
  support_name: z.string().optional(), // 후원 이름, 후원일 경우에만 입력
  fee: z.string(), // 마플샵 수수료
  statement_id: z.string(), // 멤버십 서비스 내, 결제 ID
  /* TODO 일단 옵셔널로 배포해놓고 나중에 변경 */
  request_id: z.string().optional(), // 결제, 환불 묶이는 값
});

export const CreateMembershipAdjustmentSchema = z.object({
  adjustments: z.array(MembershipAdjustmentSchema), // 정산 데이터 리스트
});

export const ApproveMembershipWithdrawControllerReqBodySchema = z.object({
  reason: z.string().optional(),
  real_amount: z.string(),
});

export const CancelMembershipWithdrawControllerReqBodySchema = z.object({
  reason: z.string().optional(),
});

export const ChangeMembershipWithdrawControllerReqBodySchema = z.object({
  reason: z.string().optional(),
  real_amount: z.string().optional(),
});

export const ChangeMembershipAdjustmentCreatorRatioSchema = z.object({
  creator_ratio: z.number().gte(0).lte(100),
});
